var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.backRoute)?_c('b-button',{staticClass:"is-danger",attrs:{"tag":"router-link","is-loading":_vm.isLoading,"to":_vm.backRoute}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_c('b-button',{staticClass:"is-danger",on:{"click":_vm.triggerFunction}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }